
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30910',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30910",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55479",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8442",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11894",
  "I18n": "static-7.1691",
  "quartz": "static-1.7575",
  "quartz-config": "static-1.1353",
  "quartz-core": "static-1.6794",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1024",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55466",
  "feedback-utils": "static-1.55470",
  "forms-embed-utils-lib": "static-1.4869",
  "forms-utils-lib": "static-1.13226",
  "foundations-assets": "static-1.5290",
  "foundations-components": "static-1.8638",
  "foundations-theming": "static-1.4881",
  "hub-http": "static-1.6613",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12201",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4186",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17134",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5616",
  "react-virtualized": "static-2.110",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.511",
  "tinymce-plugins": "static-1.58385",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8840",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3852",
  "quartz-webpack": "static-1.3799",
  "foundations-theming-specialty": "static-1.2597",
  "property-description-translator": "static-1.4225",
  "HeadJS": "static-2.811",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3553",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4711",
  "jasmine-runner": "static-1.6849",
  "opentelemetry-fe-types": "static-1.188",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4921",
  "mobile-manifest-mixins": "static-1.592",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.563",
  "quartz-auth": "static-1.1250",
  "quartz-head": "static-1.1240",
  "quartz-i18n": "static-1.1250",
  "quartz-routing": "static-1.1005",
  "quartz-test": "static-1.1250",
  "quartz-tracking": "static-1.954",
  "trellis-components": "static-1.2932",
  "ui-fonts": "static-1.1156",
  "usage-tracker-container": "static-1.7705",
  "usage-tracker-core": "static-1.7565",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.291",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8583",
  "sanitize-text": "static-1.8559",
  "PatternValidationJS": "static-1.3291",
  "ReduxMessenger": "static-2.10773",
  "outpost": "static-1.4538",
  "rpc-client-utils": "static-1.5070",
  "sanitize": "static-1.4873",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4907",
  "floating-ui": "static-1.66",
  "hs-story-utils": "static-1.9827",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.88",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2913",
  "bend-plugin-foundations-theming": "static-1.3364",
  "foundations-theming-base": "static-1.3866",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.355",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9895",
  "atom": "static-1.5481",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8325",
  "ContentUtils": "static-1.69316",
  "data-token-picker": "static-1.17023",
  "file-manager-components": "static-1.24708",
  "FileManagerCore": "static-1.40207",
  "FileManagerLib": "static-1.40348",
  "frontend-preferences-client": "static-1.8321",
  "hub-http-contrib": "static-1.3429",
  "interframe": "static-3.5145",
  "layout-dnd-components": "static-1.13109",
  "layout-dnd-utils": "static-1.12084",
  "property-translator": "static-1.5784",
  "react-codemirror": "static-1.11043",
  "react-colorpicker": "static-2.10614",
  "reference-resolvers-lite": "static-1.8505",
  "rich-text-lib": "static-1.20447",
  "tinymce-data": "static-1.41356",
  "tinymce-themes": "static-1.57241",
  "ui-addon-emoji-picker": "static-1.10271",
  "ui-addon-sales-email": "static-1.5605",
  "ui-brand-identity-lib": "static-1.16758",
  "bender-build-tools": "static-1.3472",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.104",
  "hub-http-shared-msw-handlers": "static-1.10775",
  "hubspotter-http-shared-msw-handlers": "static-1.10773",
  "usage-tracker-session-replay": "static-1.5401",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "trellis-theming": "static-1.1382",
  "tanstack-virtual": "static-1.41",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.480",
  "chirp-fetch": "static-1.2302",
  "stylex-utils": "static-1.157",
  "chatspot-core": "static-1.23430",
  "copilot-toolkit": "static-1.12013",
  "customer-data-objects-ui-components": "static-1.13432",
  "data-fetching-client": "static-1.10048",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5161",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29478",
  "usage-tracker": "static-1.7715",
  "cms-field-types": "static-1.5214",
  "content-icons-ui": "static-1.2415",
  "integrations-lib": "static-1.17266",
  "customer-data-objects": "static-1.8096",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1974",
  "apollo-link-hub-http": "static-2.5016",
  "apollo-stack-hubspot": "static-3.97",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4546",
  "poll-commands": "static-1.3874",
  "ui-addon-iframeable": "static-1.9482",
  "video-components-external": "static-1.12313",
  "video-data-lib": "static-1.35971",
  "breeze-artifacts-sdk": "static-1.639",
  "audio-components": "static-1.6473",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29950",
  "FileManagerImages": "static-1.37859",
  "foundations-components-legacy": "static-1.1663",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.662",
  "ui-universal-auth": "static-1.9595",
  "urlinator": "static-1.4918",
  "video-components": "static-1.14315",
  "video-embed": "static-1.36805",
  "ts-schema": "static-1.4355",
  "ContentData": "static-1.69391",
  "layout-data-lib": "static-1.10409",
  "react-dnd-compat": "static-1.5015",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1947",
  "external-options-client-types": "static-1.4403",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7299",
  "hs-promise-utils": "static-1.5992",
  "inbound-db-properties-service-client": "static-1.4104",
  "NamespacedHubStyle": "static-2.9320",
  "growth-onboarding-confetti": "static-1.3467",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11549",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5839",
  "magpie-types": "static-1.5299",
  "simple-logging-lib": "static-1.3455",
  "avatar-components": "static-1.2885",
  "customer-data-ui-utilities": "static-1.10235",
  "growth-onboarding-feedback-components": "static-1.6987",
  "flux-actions": "static-1.377",
  "hubspot-apollo-client": "static-1.5277",
  "integrations-error-boundary-lib": "static-1.14681",
  "integrations-tracking-lib": "static-1.6014",
  "laboratory-lib": "static-3.7553",
  "native-integrations-shared-strings": "static-1.8165",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10674",
  "unified-auth": "static-1.1109",
  "breeze-engine-chat-components": "static-1.952",
  "breeze-engine-core": "static-1.1252",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1037",
  "navigation-messaging": "static-1.8351",
  "content-media-composition-data-lib": "static-1.13447",
  "content-media-compositions": "static-2.17454",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19538",
  "nudge-client-utils": "static-1.3291",
  "unified-auth-core-lib": "static-1.1391",
  "social-insights-client-types": "static-1.22804",
  "advanced-menus-core": "static-1.15706",
  "advanced-menus-lib": "static-1.12511",
  "ExportDialog": "static-6.10779",
  "ui-memberships-settings-lib": "static-1.35030",
  "conditional-properties-service-client": "static-1.4077",
  "crm-pipelines-api-client-types": "static-1.4408",
  "fdsr-migration-layer": "static-1.418",
  "framework-builder-read-service-client": "static-1.4283",
  "framework-data-schema-quick-fetch": "static-1.7204",
  "inbound-db-meta-service-client": "static-1.3735",
  "multi-currency-client-types": "static-1.3972",
  "persist-promise": "static-1.4104",
  "foundations-components-test-utils": "static-1.6121",
  "reactive-lib": "static-1.1124",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.736",
  "universal-page-editor-lib": "static-1.3413",
  "adobe-sign-auth-lib": "static-1.638",
  "ads-unified-auth-lib": "static-1.1713",
  "custom-vendor-connection-lib": "static-1.159",
  "google-sheets-integration-lib": "static-1.1202",
  "microsoft-drive-auth-lib": "static-1.363",
  "surveymonkey-integration-lib": "static-1.716",
  "slack-ui-library": "static-1.10801",
  "bend-plugin-pulse": "static-1.540",
  "event-emitter": "static-1.1361",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3048",
  "nudge-renderer-utils": "static-1.3367",
  "onboarding-tours": "static-1.17282",
  "whisper-core-api": "static-1.7505",
  "fsm": "static-1.4156",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15705",
  "simple-menus-lib": "static-1.17222",
  "settings-ui-lib": "static-1.12932",
  "crm-record-cards-service-types": "static-1.3831",
  "location-customization-utils-lib": "static-1.10288",
  "getting-started-shared-tasks": "static-1.19429",
  "growth-data-modal": "static-1.6027",
  "growth-onboarding-next-action-utils": "static-1.2859",
  "navigation-components": "static-1.19024",
  "onboarding-tours-client": "static-1.5497",
  "onboarding-tours-utils": "static-1.1349",
  "ui-shepherd-tracker": "static-1.8055",
  "user-context": "static-1.5474",
  "react-flip-move": "static-1.81",
  "onboarding-data-sync-lib": "static-1.2710",
  "growth-onboarding-next-action-components": "static-1.2887",
  "user-context-client": "static-1.4911",
  "nest": "static-1.639",
  "getting-started-shared-tasks-store": "static-1.18547",
  "InboxConnectUtils": "static-4.15720",
  "meetings-connect-utils-lib": "static-1.8017",
  "onboarding-scopes": "static-1.6855"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30910",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55479",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8442",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11894",
  "I18n": "/I18n/static-7.1691",
  "quartz": "/quartz/static-1.7575",
  "quartz-config": "/quartz-config/static-1.1353",
  "quartz-core": "/quartz-core/static-1.6794",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1024",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55466",
  "feedback-utils": "/feedback-utils/static-1.55470",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4869",
  "forms-utils-lib": "/forms-utils-lib/static-1.13226",
  "foundations-assets": "/foundations-assets/static-1.5290",
  "foundations-components": "/foundations-components/static-1.8638",
  "foundations-theming": "/foundations-theming/static-1.4881",
  "hub-http": "/hub-http/static-1.6613",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12201",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4186",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17134",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5616",
  "react-virtualized": "/react-virtualized/static-2.110",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "tinymce-plugins": "/tinymce-plugins/static-1.58385",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8840",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3852",
  "quartz-webpack": "/quartz-webpack/static-1.3799",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2597",
  "property-description-translator": "/property-description-translator/static-1.4225",
  "HeadJS": "/HeadJS/static-2.811",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3553",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4711",
  "jasmine-runner": "/jasmine-runner/static-1.6849",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.188",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4921",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.592",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.563",
  "quartz-auth": "/quartz-auth/static-1.1250",
  "quartz-head": "/quartz-head/static-1.1240",
  "quartz-i18n": "/quartz-i18n/static-1.1250",
  "quartz-routing": "/quartz-routing/static-1.1005",
  "quartz-test": "/quartz-test/static-1.1250",
  "quartz-tracking": "/quartz-tracking/static-1.954",
  "trellis-components": "/trellis-components/static-1.2932",
  "ui-fonts": "/ui-fonts/static-1.1156",
  "usage-tracker-container": "/usage-tracker-container/static-1.7705",
  "usage-tracker-core": "/usage-tracker-core/static-1.7565",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.291",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8583",
  "sanitize-text": "/sanitize-text/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.3291",
  "ReduxMessenger": "/ReduxMessenger/static-2.10773",
  "outpost": "/outpost/static-1.4538",
  "rpc-client-utils": "/rpc-client-utils/static-1.5070",
  "sanitize": "/sanitize/static-1.4873",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4907",
  "floating-ui": "/floating-ui/static-1.66",
  "hs-story-utils": "/hs-story-utils/static-1.9827",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2913",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3364",
  "foundations-theming-base": "/foundations-theming-base/static-1.3866",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.355",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9895",
  "atom": "/atom/static-1.5481",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8325",
  "ContentUtils": "/ContentUtils/static-1.69316",
  "data-token-picker": "/data-token-picker/static-1.17023",
  "file-manager-components": "/file-manager-components/static-1.24708",
  "FileManagerCore": "/FileManagerCore/static-1.40207",
  "FileManagerLib": "/FileManagerLib/static-1.40348",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8321",
  "hub-http-contrib": "/hub-http-contrib/static-1.3429",
  "interframe": "/interframe/static-3.5145",
  "layout-dnd-components": "/layout-dnd-components/static-1.13109",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12084",
  "property-translator": "/property-translator/static-1.5784",
  "react-codemirror": "/react-codemirror/static-1.11043",
  "react-colorpicker": "/react-colorpicker/static-2.10614",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8505",
  "rich-text-lib": "/rich-text-lib/static-1.20447",
  "tinymce-data": "/tinymce-data/static-1.41356",
  "tinymce-themes": "/tinymce-themes/static-1.57241",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10271",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5605",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16758",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.104",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10775",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10773",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5401",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "trellis-theming": "/trellis-theming/static-1.1382",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.480",
  "chirp-fetch": "/chirp-fetch/static-1.2302",
  "stylex-utils": "/stylex-utils/static-1.157",
  "chatspot-core": "/chatspot-core/static-1.23430",
  "copilot-toolkit": "/copilot-toolkit/static-1.12013",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13432",
  "data-fetching-client": "/data-fetching-client/static-1.10048",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5161",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29478",
  "usage-tracker": "/usage-tracker/static-1.7715",
  "cms-field-types": "/cms-field-types/static-1.5214",
  "content-icons-ui": "/content-icons-ui/static-1.2415",
  "integrations-lib": "/integrations-lib/static-1.17266",
  "customer-data-objects": "/customer-data-objects/static-1.8096",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1974",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5016",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4546",
  "poll-commands": "/poll-commands/static-1.3874",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9482",
  "video-components-external": "/video-components-external/static-1.12313",
  "video-data-lib": "/video-data-lib/static-1.35971",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.639",
  "audio-components": "/audio-components/static-1.6473",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29950",
  "FileManagerImages": "/FileManagerImages/static-1.37859",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1663",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.662",
  "ui-universal-auth": "/ui-universal-auth/static-1.9595",
  "urlinator": "/urlinator/static-1.4918",
  "video-components": "/video-components/static-1.14315",
  "video-embed": "/video-embed/static-1.36805",
  "ts-schema": "/ts-schema/static-1.4355",
  "ContentData": "/ContentData/static-1.69391",
  "layout-data-lib": "/layout-data-lib/static-1.10409",
  "react-dnd-compat": "/react-dnd-compat/static-1.5015",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1947",
  "external-options-client-types": "/external-options-client-types/static-1.4403",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7299",
  "hs-promise-utils": "/hs-promise-utils/static-1.5992",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4104",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9320",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3467",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11549",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5839",
  "magpie-types": "/magpie-types/static-1.5299",
  "simple-logging-lib": "/simple-logging-lib/static-1.3455",
  "avatar-components": "/avatar-components/static-1.2885",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10235",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6987",
  "flux-actions": "/flux-actions/static-1.377",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5277",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14681",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6014",
  "laboratory-lib": "/laboratory-lib/static-3.7553",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8165",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10674",
  "unified-auth": "/unified-auth/static-1.1109",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.952",
  "breeze-engine-core": "/breeze-engine-core/static-1.1252",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1037",
  "navigation-messaging": "/navigation-messaging/static-1.8351",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13447",
  "content-media-compositions": "/content-media-compositions/static-2.17454",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19538",
  "nudge-client-utils": "/nudge-client-utils/static-1.3291",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1391",
  "social-insights-client-types": "/social-insights-client-types/static-1.22804",
  "advanced-menus-core": "/advanced-menus-core/static-1.15706",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12511",
  "ExportDialog": "/ExportDialog/static-6.10779",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35030",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4077",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4408",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.418",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4283",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7204",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3735",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3972",
  "persist-promise": "/persist-promise/static-1.4104",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6121",
  "reactive-lib": "/reactive-lib/static-1.1124",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.736",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3413",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.638",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1713",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.159",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1202",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.363",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.716",
  "slack-ui-library": "/slack-ui-library/static-1.10801",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.540",
  "event-emitter": "/event-emitter/static-1.1361",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3048",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3367",
  "onboarding-tours": "/onboarding-tours/static-1.17282",
  "whisper-core-api": "/whisper-core-api/static-1.7505",
  "fsm": "/fsm/static-1.4156",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15705",
  "simple-menus-lib": "/simple-menus-lib/static-1.17222",
  "settings-ui-lib": "/settings-ui-lib/static-1.12932",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3831",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10288",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19429",
  "growth-data-modal": "/growth-data-modal/static-1.6027",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2859",
  "navigation-components": "/navigation-components/static-1.19024",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5497",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1349",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8055",
  "user-context": "/user-context/static-1.5474",
  "react-flip-move": "/react-flip-move/static-1.81",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2710",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2887",
  "user-context-client": "/user-context-client/static-1.4911",
  "nest": "/nest/static-1.639",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18547",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15720",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8017",
  "onboarding-scopes": "/onboarding-scopes/static-1.6855"
}
};
